import { Controller } from "@hotwired/stimulus"
import { suppressProgressBar } from "../lib/helpers"

export default class extends Controller {
  static targets = ["circle"]
  static values = {enabled: Boolean}

  disconnect() {
    clearTimeout(this.timer)
    if (this.sliding && !this.armed) {
      document.dispatchEvent(new CustomEvent("fsp:decrement"))
    }
  }

  slide(event) {
    if (this.armed) return // delayed requestSubmit: let native submit through
    event.preventDefault()
    if (this.sliding) return

    this.sliding = true
    document.dispatchEvent(new CustomEvent("fsp:increment"))

    const circle = this.circleTarget

    if (this.enabledValue) {
      circle.classList.remove("left-5.5", "bg-emerald-400")
      circle.classList.add("left-[5px]", "bg-amber-400")
    } else {
      circle.classList.remove("left-[5px]", "bg-gray-400", "dark:bg-gray-500")
      circle.classList.add("left-5.5", "bg-amber-400")
    }

    this.timer = setTimeout(() => {
      this.armed = true
      document.dispatchEvent(new CustomEvent("fsp:decrement"))
      suppressProgressBar()
      this.element.requestSubmit()
    }, 200)
  }
}
